import React, { PureComponent } from 'react';

import { toast, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

class Toast extends PureComponent {
  state = {
    error: this.props.error,
    success: this.props.success,
    icon: this.props.icon,
  };

  // Errors/Success messages
  notifySuccess = msg => toast.success(msg);
  notifyError = msg => toast.error(msg);

  render() {
    if (this.props.error) {
      this.notifyError(this.props.error);
    } else if (this.props.success) {
      this.notifySuccess(this.props.success);
    }

    return this.props.icon ? (
      <i className='icon_error fa fa-frown-o'>
        <ToastContainer />
      </i>
    ) : (
      <ToastContainer />
    );
  }
}

export default Toast;
